import { DocContent, DocNode } from '../models/types';
import { mockDocContent, mockDocIndex } from '../mock/docsIndex';

export class DocsIndexService {
  static async fetchTree(): Promise<DocNode[]> {
    try {
      const response = await fetch('/api/docs/tree');
      if (!response.ok) {
        throw new Error(`Docs tree API returned ${response.status}`);
      }
      return (await response.json()) as DocNode[];
    } catch (error) {
      console.warn('Falling back to mock doc index', error);
      return mockDocIndex;
    }
  }

  static async fetchContent(path: string): Promise<DocContent> {
    try {
      const response = await fetch(`/api/docs/content?path=${encodeURIComponent(path)}`);
      if (!response.ok) {
        throw new Error(`Docs content API returned ${response.status}`);
      }
      return (await response.json()) as DocContent;
    } catch (error) {
      console.warn('Falling back to mock doc content', error);
      return mockDocContent;
    }
  }
}
